import React from 'react';
import { useTranslation } from '../../contexts/LanguageContext';

const ViewModeSelector = ({ viewMode, setViewMode }) => {
  const { t } = useTranslation();

  return (
    <section className="settings-section">
      <h3>👁️ {t('settings.viewMode', 'View Mode')}</h3>
      <p className="section-description">{t('settings.viewModeDescription', 'Choose how you want to view the chess board')}</p>
      
      <div className="view-mode-selector">
        <button
          className={`view-mode-button ${viewMode === 'topdown' ? 'active' : ''}`}
          onClick={() => setViewMode('topdown')}
          data-testid="view-topdown"
        >
          <div className="view-mode-icon">📐</div>
          <div className="view-mode-content">
            <strong>{t('settings.topDown', 'Top-Down')} ({t('settings.default')})</strong>
            <p>{t('settings.topDownDescription', 'Flat, straight-down view like traditional boards')}</p>
          </div>
        </button>

        <button
          className={`view-mode-button ${viewMode === '3d' ? 'active' : ''}`}
          onClick={() => setViewMode('3d')}
          data-testid="view-3d"
        >
          <div className="view-mode-icon">🎨</div>
          <div className="view-mode-content">
            <strong>{t('settings.perspective3D', '3D Perspective')}</strong>
            <p>{t('settings.perspective3DDescription', 'Classic 2D pieces with dynamic 3D board angle')}</p>
          </div>
        </button>
      </div>
    </section>
  );
};

export default ViewModeSelector;
